import register from '@/components/features/cms/blocks/BlogOverview/register';
import { BlogOverview } from './BlogOverview';

register(BlogOverview);
